/**
 * Map URL pathname to readable page name
 * @param {string} pathname - URL pathname
 * @returns {string} - Readable page name
 */
export const getPageName = (pathname) => {
  // Remove query parameters and hash
  const cleanPath = pathname.split('?')[0].split('#')[0];

  // Page name mapping
  const pageMap = {
    '/': 'Home',
    '/mindyourmusic': 'Mind Your Music',
    '/quiz': 'Quiz',
    '/quiz/history': 'Quiz History',
    '/showdown': 'Showdown',
    '/playlist': 'Playlist',
    '/artist': 'Artist',
    '/login': 'Sign In',
    '/signup': 'Sign Up',
    '/verify-email': 'Email Verification',
    '/reset-password': 'Password Reset',
    '/auth/callback': 'Authentication',
    '/AdminLogin': 'Admin Login',
    '/AdminConfig': 'Dashboard Home Config',
    '/AdminHomePage': 'Admin Dashboard',
    '/AdminRequestCompact': 'Request Compact',
    '/AdminPlaylist': 'Admin Playlist',
    '/AdminRequests': 'Admin Requests',
    '/SongqRequests': 'Songq Requests',
    '/analytics': 'Analytics',
    '/AllPlaylistScreen': 'All Playlists',
    '/AllSongScreen': 'All Songs',
    '/DuplicateSongs': 'Duplicate Songs',
    '/LookUpTabs': 'Lookups',
    '/ImportedSongs': 'Imported Songs',
    '/AdminQuiz': 'Admin Quiz',
    '/AdminLookup': 'Quiz Lookups',
    '/AdminQuizImport': 'Quiz Import',
    '/AdminAiQGen': 'AI Question Generator'
  };

  // Check exact match first
  if (pageMap[cleanPath]) {
    return pageMap[cleanPath];
  }

  // Handle dynamic routes
  if (cleanPath.startsWith('/playlist/')) {
    return 'Playlist';
  }

  if (cleanPath.startsWith('/artist/')) {
    return 'Artist';
  }

  // Handle admin routes
  if (cleanPath.startsWith('/Admin')) {
    return 'Admin Page';
  }

  // Default: return formatted pathname
  return cleanPath
    .split('/')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ') || 'Home';
};

/**
 * Get page icon/emoji for display
 * @param {string} pathname - URL pathname
 * @returns {string} - Emoji or icon identifier
 */
export const getPageIcon = (pathname) => {
  const cleanPath = pathname.split('?')[0].split('#')[0];

  const iconMap = {
    '/': '🏠',
    '/mindyourmusic': '🎵',
    '/quiz': '🧠',
    '/quiz/history': '📜',
    '/showdown': '🎤',
    '/playlist': '📀',
    '/artist': '👤'
  };

  if (iconMap[cleanPath]) {
    return iconMap[cleanPath];
  }

  if (cleanPath.startsWith('/playlist/')) {
    return '📀';
  }

  if (cleanPath.startsWith('/artist/')) {
    return '👤';
  }

  if (cleanPath.startsWith('/Admin')) {
    return '⚙️';
  }

  return '📄';
};

const pageNameMapper = {
  getPageName,
  getPageIcon
};

export default pageNameMapper;

